"use client";

import Link from "next/link";
import HubSpotMeetings from "../../__components/HubSpotMeetings";
import styles from "./casual.module.scss";

export default function CasualClient() {
  return (
    <div className={`${styles.page} casual-page`}>
      {/* Header */}
      <section className={styles.hero}>
        <span className={`${styles.heroSub} fade-up`}>CASUAL INTERVIEW</span>
        <h1 className={`${styles.heroTitle} fade-up`}>カジュアル面談</h1>
        <p className={`${styles.heroDesc} fade-up`}>
          「自分のスキルが通用するか知りたい」「会社の雰囲気を知りたい」
          <br />
          そんな方は、選考要素なしのカジュアル面談へお越しください。
        </p>
      </section>

      {/* Casual Container */}
      <section className={styles.casualSection}>
        <div className={styles.casualContainer}>
          {/* Left: Information */}
          <div className={styles.casualInfo}>
            <div className={`${styles.infoBlock} fade-up`}>
              <h2>カジュアル面談について</h2>
              <p className={styles.infoText}>
                カジュアル面談は、選考要素のない30分程度のオンライン面談です。
                <br />
                会社の雰囲気や働き方、求められるスキルなど、気になることを
                <br />
                お気軽にお聞きいただけます。
              </p>
            </div>

            <div className={`${styles.infoBlock} fade-up`}>
              <h2>実施方法</h2>
              <p className={styles.infoText}>
                オンライン（Google Meet）で実施いたします。
                <br />
                ご都合の良い日時をお選びいただけます。
              </p>
            </div>

            <div className={`${styles.infoBlock} fade-up`}>
              <h2>お電話でのお問い合わせ</h2>
              <p className={styles.infoText}>
                面談に関するご質問はお電話でも承っております。
              </p>
              <a
                href="tel:050-1809-8296"
                className={`${styles.contactTel} hover-target`}
              >
                050-1809-8296
              </a>
              <span className={styles.telNote}>
                受付時間：平日 10:00 〜 19:00
              </span>
            </div>

            <div className={`${styles.infoBlock} fade-up`}>
              <div className={styles.faqLinkBox}>
                <p
                  className={styles.infoText}
                  style={{ marginBottom: "0.5rem" }}
                >
                  <strong>正式に応募したい方は？</strong>
                </p>
                <p className={styles.infoText} style={{ fontSize: "0.85rem" }}>
                  エントリーフォームから正式にご応募いただけます。
                </p>
                <div className={styles.faqLinks}>
                  <Link
                    href="/recruit/entry"
                    className={`${styles.faqLinkBtn} hover-target`}
                  >
                    エントリーフォームへ →
                  </Link>
                  <Link
                    href="/recruit"
                    className={`${styles.faqLinkBtn} hover-target`}
                  >
                    募集職種を見る →
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Right: HubSpot Form Area */}
          <div className={styles.formArea}>
            <h2 className={`${styles.formTitle} fade-up`}>
              カジュアル面談申し込みフォーム
            </h2>
            <div>
              <div className={`${styles.hubspotContainer} fade-up`}>
                <HubSpotMeetings meetingUrl="https://meetings-na2.hubspot.com/tsubasa1/casual?embed=true" />
              </div>
              <p className={styles.privacyNote}>
                お客様の個人情報は、
                <Link href="/privacy">プライバシーポリシー</Link>
                に基づき適切に管理いたします。
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

